module.exports = __webpack_public_path__ + "img/about_inner2.c07fb3ba.png";